import { render, staticRenderFns } from "./StreamController.vue?vue&type=template&id=2b8dc657&scoped=true&"
import script from "./StreamController.vue?vue&type=script&lang=ts&"
export * from "./StreamController.vue?vue&type=script&lang=ts&"
import style0 from "./StreamController.vue?vue&type=style&index=0&id=2b8dc657&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8dc657",
  null
  
)

export default component.exports